import React from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Dialog from 'app/components/base/Dialog'
import Divider from 'app/components/base/Divider'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import BidHistoryCard from './BidHistoryCard'

interface BidHistoryDialogProps {
  open: boolean
  onClose: () => void
  bids: BidPublicModel[]
  currency: string
}

const BidHistoryDialog: RFC<BidHistoryDialogProps> = ({
  open,
  onClose,
  bids,
  currency
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={<FormattedMessage defaultMessage="Bid History" />}
      dialogSx={{
        ...Platform.select({
          web: {
            '& .MuiDialog-paper': {
              py: 5,
              px: 2,
              m: { xs: 2, md: 4 },
              width: '100%',
              maxWidth: '527px',
              maxHeight: '463px',
              borderRadius: 2
            }
          }
        })
      }}
      contentSx={{ mb: 0 }}
    >
      <Stack
        direction="column"
        spacing={1}
        divider={<Divider />}
        {...Platform.select({
          web: {
            sx: {
              px: { sm: 11 }
            }
          },
          native: {
            divider: <Divider style={{ marginBottom: 8, marginTop: 8 }} />
          }
        })}
      >
        {bids.map((item) => (
          <BidHistoryCard
            key={item.created_at}
            createdAt={item.created_at}
            price={item.price}
            currency={currency}
            userName={item.hidden_user_name}
          />
        ))}
      </Stack>
    </Dialog>
  )
}

export default BidHistoryDialog
